import { type FC, useState } from 'react';

import { Checkbox } from '@crehana/compass.ui';
import { boldFormatter, useTranslation } from '@crehana/i18n';

import PaginatedCardTable from '../PaginatedCardTable';

interface IInfoTableProps {
  recordsToUpdate?: { email: string; message: string }[];
}

//TODO: This should be model-agnostic and configurable
const InfoTable: FC<IInfoTableProps> = ({ recordsToUpdate }) => {
  const { t } = useTranslation();
  const [checkedItems, setCheckedItems] = useState<string[]>([]);

  const handleToggleItem = (item: string) => {
    setCheckedItems(prevCheckedItems => {
      if (prevCheckedItems.includes(item)) {
        return prevCheckedItems.filter(checkedItem => checkedItem !== item);
      } else {
        return [...prevCheckedItems, item];
      }
    });
  };

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!recordsToUpdate) return <></>;

  return (
    <PaginatedCardTable
      title={t('TABLE_STEP_2_DETAIL_INFO_TITLE')}
      description={t('TABLE_STEP_2_DETAIL_INFO_DESC', {
        formatter: boldFormatter,
      })}
      errors={recordsToUpdate || []}
      cols={[
        {
          keyAccess: 'email',
          label: t('TABLE_STEP_2_DETAIL_EMAIL'),
          transform: (value: string, idx: number) => (
            <Checkbox
              size="s"
              checked={checkedItems.includes(`${value}-${idx}`)}
              onChange={() => handleToggleItem(`${value}-${idx}`)}
              title={value || t('TABLE_STEP_2_DETAIL_EMAIL_EMPTY')}
            />
          ),
        },
        {
          keyAccess: 'message',
          label: t('TABLE_STEP_2_DETAIL_INFO'),
          transform: (value: string) => (
            <span className="tw-text-info-400 tw-font-semibold">{value}</span>
          ),
        },
      ]}
    />
  );
};

export default InfoTable;
